import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import mitt from 'mitt'
import ToomanSvg from '@/components/ToomanSvg.vue'
import VueLazyLoad from 'vue3-lazyload'

const currentVersion = '1.0.7'
const storedVersion = localStorage.getItem('appVersion')

if (!storedVersion) {
  localStorage.setItem('appVersion', currentVersion)
} else if (storedVersion !== currentVersion) {
  localStorage.clear()
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`)
  })
  localStorage.setItem('appVersion', currentVersion)
  location.reload()
}

const emitter = mitt()
const app = createApp(App)

app.component('ToomanSvg', ToomanSvg)
app.use(VueLazyLoad, {})

app.use(router)

app.mixin({
  methods: {
    sendToClub: function (clubNumber) {
      const mutation = `
      mutation register_club {
        clubRegister(phone: "${clubNumber}") {
          status
        }
      }
      `
      this.$fetchGraphQL(mutation)
        .then(res => {
          if (res.data.clubRegister.status === 'success') {
            this.fire({
              icon: 'success',
              title: 'ثبت شد',
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            this.fire({
              icon: 'error',
              title: 'شماره تماس را به صورت صحیح وارد کنید',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
    },
    addToCart: function (product, popup = true) {
      const cart = JSON.parse(localStorage.getItem('cart')) || {}
      if (!cart[product.id]) {
        cart[product.id] = { ...product, count: 1 }
      } else {
        cart[product.id].count++
      }
      localStorage.setItem('cart', JSON.stringify(cart))
      this.emitter.emit('updateCart')
      if (popup) {
        this.fire({
          icon: 'success',
          title: 'به سبد خرید اضافه شد',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    addToWish: function (product) {
      const wish = JSON.parse(localStorage.getItem('wish')) || {}
      if (!wish[product.id]) {
        wish[product.id] = { ...product }
      }
      localStorage.setItem('wish', JSON.stringify(wish))
      this.emitter.emit('updateWish')
    },
    removeFromCart: function (product) {
      const cart = JSON.parse(localStorage.getItem('cart')) || {}
      delete cart[product.id]
      localStorage.setItem('cart', JSON.stringify(cart))

      let concept = JSON.parse(localStorage.getItem('concept')) || []
      concept = concept.filter(c => c.product !== product.id)
      localStorage.setItem('concept', JSON.stringify(concept))

      this.emitter.emit('updateCart')
    },
    removeFromWish: function (product) {
      const wish = JSON.parse(localStorage.getItem('wish')) || {}
      delete wish[product.id]
      localStorage.setItem('wish', JSON.stringify(wish))
      this.emitter.emit('updateWish')
    },
    fire: function (options) {
      return new Promise((resolve, reject) => {
        // Create the modal elements
        const modal = document.createElement('div')
        modal.classList.add('custom-modal')
        document.body.classList.add('modal-open')
        modal.style.opacity = '0'
        modal.innerHTML = `
          <div class="custom-modal-content">
            ${options.icon ? `<lord-icon src="/img/icons/${options.icon}.json" trigger="loop" delay="${options.timer ? (options.timer < 1000 ? 0 : options.timer - 1000) : 2000}"></lord-icon>` : ''}            
            <div class="custom-modal-header">${options.title || ''}</div>
            <div class="custom-modal-body">
              <p>${options.text || ''}</p>
              ${options.imageUrl ? `<img src="${options.imageUrl}" alt="${options.imageAlt}" class="w-100">` : ''}
              ${options.input === 'text' ? `<input class="form-control" type="text" value="${options.inputValue ? options.inputValue : ''}" ${Object.keys(options.inputAttributes || {}).map(attr => `${attr}="${options.inputAttributes[attr]}"`).join(' ')}>` : ''}
              ${options.input === 'number' ? `<input class="form-control" type="number" value="${options.inputValue ? options.inputValue : ''}" ${Object.keys(options.inputAttributes || {}).map(attr => `${attr}="${options.inputAttributes[attr]}"`).join(' ')}>` : ''}
              ${options.input ? '<hr>' : ''}
              <p class="my-2 text-secondary">${options.textImage || ''}</p>
              ${options.imageInput ? '<input class="form-control my-2" id="image-modal" type="file" />' : ''}
              ${options.input === 'file' ? `<input class="form-control" type="file" ${Object.keys(options.inputAttributes || {}).map(attr => `${attr}="${options.inputAttributes[attr]}"`).join(' ')}>` : ''}
              ${options.imageInput ? '<hr>' : ''}
            <div class="custom-modal-footer">
              ${options.showConfirmButton !== false ? `<button class="btn btn-primary custom-modal-button">${options.confirmButtonText || 'OK'}</button>` : ''}
              ${options.showCancelButton ? `<button class="btn btn-danger cancel-modal-button">${options.cancelButtonText || 'cancel'}</button>` : ''}
              <div class="custom-modal-loader">Loading...</div>
            </div>
          </div>
        `

        // Append the modal to the body
        document.body.appendChild(modal)

        // Show the modal
        setTimeout(() => { modal.style.opacity = '1' }, 10)

        const button = modal.querySelector('.custom-modal-button')
        const cancel = modal.querySelector('.cancel-modal-button')
        const loader = modal.querySelector('.custom-modal-loader')
        const input = modal.querySelector('input[type="text"]') || modal.querySelector('input[type="number"]')
        const file = modal.querySelector('input[type="file"]')
        const image = modal.querySelector('input[id="image-modal"]')

        function close () {
          resolve({ value: input ? input.value : null, isConfirmed: false })
          modal.style.opacity = '0'
          setTimeout(() => { try { document.body.removeChild(modal); document.body.classList.remove('modal-open') } catch {} }, 500)
        }

        if (button) {
          // Add click event to the button to show loader and handle input
          button.addEventListener('click', function () {
            if (options.showLoaderOnConfirm) {
              loader.style.opacity = 'inline-block'
            }
            resolve({ value: input ? input.value : null, isConfirmed: true, image: image ? image.files[0] : null, file: file ? file.files[0] : null })
            modal.style.opacity = '0'
            setTimeout(() => { document.body.removeChild(modal); document.body.classList.remove('modal-open') }, 500)
          })
          try {
            input.addEventListener('keypress', function (event) {
              if (event.key === 'Enter') {
                event.preventDefault()
                button.click()
              }
            })
          } catch {}
        }

        if (cancel) {
          // Add click event to the button to show loader and handle input
          cancel.addEventListener('click', function () {
            close()
          })
        }

        // Close the modal when clicking outside of it
        window.onclick = function (event) {
          if (event.target === modal) {
            close()
          }
        }

        if (options.timer) {
          setTimeout(() => {
            close()
          }, options.timer)
        }
      })
    },
    setMetaByObj: function (meta) {
      if (Object.prototype.hasOwnProperty.call(meta, 'index')) {
        if (meta.index) {
          document.getElementsByTagName('meta').robots.content = 'index'
          document.getElementsByTagName('meta').googlebot.content = 'index'
        } else {
          document.getElementsByTagName('meta').robots.content = 'noindex'
          document.getElementsByTagName('meta').googlebot.content = 'noindex'
        }
      } else {
        document.getElementsByTagName('meta').robots.content = 'index'
        document.getElementsByTagName('meta').googlebot.content = 'index'
      }
      try {
        document.title = meta.seoTitle
        document.querySelector("link[rel='canonical']").href = meta.canonical ? meta.canonical : window.location.href // eslint-disable-line
        document.getElementsByTagName('meta').keywords.content = meta.seoKeyword
        document.getElementsByTagName('meta').description.content = meta.seoDescription
        document.getElementsByTagName('meta')['og:title'].content = meta.seoTitle
        document.getElementsByTagName('meta')['og:url'].content = window.location.href
        document.getElementsByTagName('meta')['og:description'].content = meta.seoDescription
        document.getElementsByTagName('meta')['og:image'].content = meta.image ? this.$MEDIA + meta.image : ''
      } catch {}
    },
    checkAvailable: function (pk) {
      this.fire({
        title: 'شماره تماس را وارد کنید تا زمان موجود شدن محصول را به شما اطلاع دهیم. ',
        input: 'text',
        inputValue: this.$User ? this.$User.username : '',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'ارسال',
        cancelButtonText: 'لغو',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value.length === 11) {
            const mutation = `
            mutation available_sms {
              sendAvailableSms(phone: "${result.value}", pk: ${pk}, mode: "available_check") {
                status
              }
            }
            `
            this.$fetchGraphQL(mutation).then(res => {
              this.fire({
                icon: 'success',
                title: 'به زودی به شما اطلاع می‌دهیم',
                showConfirmButton: false,
                timer: 2000
              })
            })
          } else {
            this.fire({
              icon: 'error',
              title: 'شماره تماس خود را به صورت صحیح وارد کنید',
              showConfirmButton: false,
              timer: 2000
            })
          }
        }
      })
    },
    checkPrice: function (pk) {
      this.fire({
        title: 'شماره تماس را وارد کنید تا قیمت برای شما پیامک شود. ',
        input: 'text',
        inputValue: this.$User ? this.$User.username : '',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'ارسال',
        cancelButtonText: 'لغو',
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value.length === 11) {
            const mutation = `
            mutation available_sms {
              sendAvailableSms(phone: "${result.value}", pk: ${pk}, mode: "price_check") {
                status
              }
            }
            `
            this.$fetchGraphQL(mutation).then(res => {
              this.fire({
                icon: 'success',
                title: 'به زودی قیمت برای شما پیامک می‌شود',
                showConfirmButton: false,
                timer: 2000
              })
            })
          } else {
            this.fire({
              icon: 'error',
              title: 'شماره تماس خود را به صورت صحیح وارد کنید',
              showConfirmButton: false,
              timer: 2000
            })
          }
        }
      })
    },
    goTotop: function () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      const navbar = document.getElementById('navbar')
      const pagecontent = document.getElementById('page-content')
      const sticky = navbar.offsetTop
      if (window.pageYOffset >= sticky) {
        navbar.classList.add('fixed-top')
        pagecontent.classList.add('page-content')
      } else {
        navbar.classList.remove('fixed-top')
        pagecontent.classList.remove('page-content')
      }
    },
    strLimit: function (value, size) {
      if (!value) { return '' }
      value = value.toString()
      if (value.length <= size) {
        return value
      }
      return value.substr(0, size) + '...'
    },
    parseExtra: function (extra) {
      let result
      try {
        try {
          const ExtraQ = extra.replace('?', '').split('&')
          result = []
          for (let i = 0; i < ExtraQ.length; i++) {
            result.push([ExtraQ[i].split('=')[0], ExtraQ[i].split('=')[1]])
          }
          if (result.slice(-1) === '') {
            result.pop()
          }
          return result
        } catch {
          result = [extra.replace('?', '').split('=')[0]]
          return result
        }
      } catch {
        return []
      }
    },
    addFilter: function (q, v) {
      let NewPath = this.$route.path + '?'
      let querys
      if (v !== '') {
        if (this.$route.fullPath.includes('?')) {
          if (this.$route.fullPath.includes(q)) {
            querys = this.$route.fullPath.split('?')[1].split('&')
            for (let i = 0; i < querys.length; i++) {
              if (querys[i].includes(q)) {
                NewPath += querys[i].split('=')[0] + '=' + v + '&'
              } else {
                NewPath += querys[i] + '&'
              }
            }
          } else {
            NewPath = this.$route.fullPath += '&' + q + '=' + v
          }
        } else {
          NewPath = this.$route.fullPath += '?' + q + '=' + v
        }
      } else {
        if (this.$route.fullPath.includes(q)) {
          querys = this.$route.fullPath.split('?')[1].split('&')
          for (let i = 0; i < querys.length; i++) {
            if (!querys[i].split('?').slice(-1)[0].includes(q)) {
              NewPath += querys[i] + '&'
            }
          }
        }
      }
      if (NewPath.slice(-1) === '&') {
        NewPath = NewPath.slice(0, -1)
      }
      this.$router.push(NewPath)
    }
  }
})

const fetchGraphQL = async (query, variables = {}) => {
  try {
    const response = await axios.post(
      '/graphql/',
      {
        query: query,
        variables: variables
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    if (response.data.errors) {
      for (const error of response.data.errors) {
        if (error.message === 'Authentication required! Token missing or invalid.') {
          const cart = localStorage.getItem('cart')
          const wish = localStorage.getItem('wish')
          localStorage.clear()
          localStorage.setItem('cart', cart)
          localStorage.setItem('wish', wish)
          location.reload()
          throw error
        }
      }
    }
    return response.data
  } catch (error) {
    console.error('GraphQL Query Error:', error)
    throw error
  }
}

axios.defaults.baseURL = '/api'
app.config.globalProperties.$MEDIA = '/api/media/'
app.config.globalProperties.$RESIZE = '/api/master/resize/?img='

app.config.globalProperties.emitter = emitter
app.config.globalProperties.$axios = axios
app.config.globalProperties.$fetchGraphQL = fetchGraphQL

axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
app.config.globalProperties.$isAuthenticated = localStorage.getItem('isAuthenticated')
app.config.globalProperties.$User = JSON.parse(localStorage.getItem('User')) || { isStaff: false }

const query = `
{
  category {
    id
    slug
    seoTitle
    seoKeyword
    seoDescription
    name
    text
    video
    videoCover
    faqs{
      id,
      name,
      text
    }
    subcategories {
      id
      name
      seoTitle
      seoKeyword
      seoDescription
      slug
      text
      video
      videoCover
      faqs {
        id,
        name,
        text
      }
      category {
        slug
      }
    }
    brands {
      id
      name
      image
      view
      slug
    }
    backgroundDark
    backgroundLight
    icon
    header
    footer
    bestProducts {
      id
      available
      slug
      name
      image: PNG
      mlActivation
      specialTag
      concepts: concepts {
        id
        price
        name
        video
        videoCover
        image
        description
      }
      isOffInt
      priceAfterOff
      priceBeforeOff
      categorySlug
      subCategorySlug
      categoryId
    }
  }
  blogCategory {
    seoTitle
    seoKeyword
    seoDescription
    id
    name
    slug
    bestBlogs {
      id
      slug
      category
      rates
      image
      name
      description
    }
  },
  getBlogs(filters:{
    count:1,
    order: "-pk",
  }){
    id,
    category,
    image,
    name,
    slug,
    rates,
  }
  popup {
    id
    title
    text
  }
  userInfo {
    wallet
    username
    name: lastName
    address
    gender
    isStaff
  }
}
`
fetchGraphQL(query).then(res => {
  app.config.globalProperties.$categories = res.data.category
  app.config.globalProperties.$blogCategories = res.data.blogCategory
  app.config.globalProperties.$newBlog = res.data.getBlogs
  app.config.globalProperties.$popup = res.data.popup
  if (res.data.userInfo && !(localStorage.getItem('isAuthenticated') || false)) {
    localStorage.setItem('isAuthenticated', true)
    localStorage.setItem('User', JSON.stringify(res.data.userInfo))
    location.reload()
  }
  if (!res.data.userInfo && (localStorage.getItem('isAuthenticated') || false)) {
    const cart = localStorage.getItem('cart')
    const wish = localStorage.getItem('wish')
    localStorage.clear()
    localStorage.setItem('cart', cart)
    localStorage.setItem('wish', wish)
    location.reload()
  }
  app.mount('#app')
})
